import { faBook, faClock, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import TaskButtons from 'app/components/tests/layouts/TaskButtons';
import * as categoryConst from 'app/constants/categories';
import { NextSeo, ArticleJsonLd } from 'next-seo';
import * as dateUtils from 'app/utils/dateUtils';
import Title from 'app/components/layouts/Title';
import { AppStoreState } from 'app/redux/store';
import { useTranslation } from 'next-i18next';
import { minuteTest } from 'app/utils/test';
import { useSelector } from 'react-redux';
import { useRouter } from "next/router";
import env from '.env.json';

interface TestHeaderProps {
  initDataTest: () => void;
  description?: string;
}

const TestHeader = ({ initDataTest, description }: TestHeaderProps) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { process, test } = useSelector((state: AppStoreState) => state.test);

  description = description ?? t('tests.description', {
    name: test?.title,
    question_number: test?.questions_count,
    time: minuteTest(test?.category_id, test?.questions_count)
  });

  return (
    <div>
      <NextSeo
        title={test?.title as string}
        description={description}
      />
      <ArticleJsonLd
        type="Article"
        url={`${env.ROOT_URL}${router.asPath}`}
        title={test.title as string}
        images={[]}
        datePublished={test.created_at}
        dateModified={test.updated_at}
        authorName={`${env.APP_NAME} Team`}
        publisherName={env.APP_NAME}
        publisherLogo={`${env.ROOT_URL}/images/commons/logos/logo.webp`}
        description={description}
      />
      <div className="text-left pb-5 border-bottom">
        <Title title={test?.title || ''} />
        <div className="text-dark d-flex pt-5">
          <div className="mr-3 p-1">
            <FontAwesomeIcon className="text-success" icon={faBook} />
            <span>
              <b className="px-1">{test?.questions_count}</b>
              {t('tests.question')}
            </span>
          </div>

          <div className="mr-3 p-1">
            <FontAwesomeIcon className="text-warning" icon={faClock} />
            <span>
              <b className="px-1">{minuteTest(test?.category_id, test?.questions_count)}</b>
              {t('tests.minute')}
            </span>
          </div>

          {[...categoryConst.IELTS_TEST, categoryConst.SPEAK_BASIC].includes(Number(test?.category_id)) &&
            <div className="mr-2 p-1 calendar-test">
              <FontAwesomeIcon className="text-info" icon={faCalendarAlt} />
              <span className="pl-1">{dateUtils.format(test?.date ?? test?.created_at, 'DD-MM-YYYY')}</span>
            </div>
          }

          {process != 'complete' && ![categoryConst.IELT_SPEAK, categoryConst.SPEAK_BASIC].includes(Number(test?.category_id)) &&
            <button
              type="button"
              disabled={process == 'ready'}
              style={{ minWidth: 80 }}
              className="btn btn-sm btn-info"
              onClick={() => initDataTest()}
            >
              {t('tests.ready')}
            </button>
          }
          {process == 'complete' &&
            <button
              type="button"
              className="btn btn-sm btn-info"
              style={{ minWidth: 80 }}
              onClick={() => initDataTest()}
            >
              {t('tests.retest')}
            </button>
          }
        </div>
      </div>

      <TaskButtons />
    </div>
  )
}

export default TestHeader;
